import { AppProviders } from './providers';
import { AppRoutes } from './routes';
import '@/styles/global.css';

/**
 * App Component
 * Root application component
 */
function App() {
    return (
        <AppProviders>
            <AppRoutes />
        </AppProviders>
    );
}

export default App;
